import { render, staticRenderFns } from "./CaptureExpenses.vue?vue&type=template&id=18f62fe1&"
import script from "./CaptureExpenses.vue?vue&type=script&lang=js&"
export * from "./CaptureExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CaptureExpenses.vue"
export default component.exports